import { render, staticRenderFns } from "./FieldReadOnly.vue?vue&type=template&id=1b1332aa&scoped=true&"
import script from "./FieldReadOnly.vue?vue&type=script&lang=js&"
export * from "./FieldReadOnly.vue?vue&type=script&lang=js&"
import style0 from "./FieldReadOnly.vue?vue&type=style&index=0&id=1b1332aa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1332aa",
  null
  
)

export default component.exports